<script setup lang="ts">
import type { PropertyPriceProps } from '.';

defineProps<PropertyPriceProps>();

const min = defineModel<number | null>('min');
const max = defineModel<number | null>('max');
</script>

<template>
	<IntervalInput
		v-model:min="min"
		v-model:max="max"
		title="Valor de venda"
		unit="currency"
		min-label="Preço mínimo"
		max-label="Preço máximo"
		update-on="blur"
		input-classes="border border-white-dark-4 hover:border-primary/40 focus:border-primary hover:focus:border-primary focus-visible:ring-0"
	/>
</template>
